export const LoginKinds = {
    LOGIN_WITH_FULL_NAME_AND_BIRTHDAY: 1,
    LOGIN_WITH_MAIL_ADDRESS_AND_PASSWORD: 2,
} as const;

export type LoginKindTypes = typeof LoginKinds[keyof typeof LoginKinds];
